import { Placeholder } from './Placeholder';

export function ProductDetailPage() {
  return <Placeholder title="Jewellery Item" note="Full product editor: source vs application fields, image manager, assignment history." />;
}
